import createReactClass from 'create-react-class';
import moment from 'moment';
import React from 'react';
import { Button } from 'react-bootstrap';
import Constants from '../constants/constants';
import { userStore } from '../stores/user';
import { restrictionRequestStore } from '../stores/restrictionRequest';
import { subdivisionStore } from '../stores/subdivision';

const {
    RestrictionTypes: TYPES,
    Tabs: TABS,
    RestrictionStatuses: STATUS,
    restrictionActions: ACTIONS,
    Roles: ROLES
} = Constants;


import { territoryStore } from '../stores/territory';
import { tabsStore } from '../stores/tabs';
import { schematicStore } from '../stores/schematic';

//Actions
import { FormRequestActions } from '../actions/formRequestActions';
import { ServerActions } from '../actions/serverActions';
import { TabActions } from '../actions/tabActions';
import { SchematicAPI } from '../actions/schematicAPI';
import { ErrorAction } from '../actions/errorActions';

import { RejectReasonModal } from "./rejectReasonModal";
import { SubmissionConfirmationModal } from './submissionConfirmationModal'
import { TransferModal } from "./transferModal";

function getStateFromStores() {
    return {
        user: userStore.getSelectedRole(),
        restriction: restrictionRequestStore.getForm(),
        isModifying: restrictionRequestStore.isModifying(),
        isInEditMode: restrictionRequestStore.isInEditMode(),
        formType: restrictionRequestStore.getFormType(),
        subdivisionSelected: subdivisionStore.isSubSelected(),
        tabState: tabsStore.stateDescription(),
        printLata: userStore.getLata(),
        isDirty: restrictionRequestStore.isDirty(),
        isReadOnly: restrictionRequestStore.getReadOnly(),
        rejectReasonCodes: restrictionRequestStore.getRejectReasonCodes(),
        didMpEntryChange: schematicStore.didMpEntryChange(),
        hideActionButtons: restrictionRequestStore.getHideActionButtons()
    }
}

export const BatchButton = createReactClass({
    componentDidMount: function () {
        restrictionRequestStore.subscribe(this._onChange);
        userStore.subscribe(this._onChange);
        subdivisionStore.subscribe(this._onChange);
        territoryStore.subscribe(this._onChange);
        tabsStore.subscribe(this._onChange);
        schematicStore.subscribe(this._onChange);
    },

    componentWillUnmount: function () {
        restrictionRequestStore.unsubscribe(this._onChange);
        userStore.unsubscribe(this._onChange);
        subdivisionStore.unsubscribe(this._onChange);
        territoryStore.unsubscribe(this._onChange);
        tabsStore.unsubscribe(this._onChange);
        schematicStore.unsubscribe(this._onChange)
    },

    getInitialState: function () {
        return getStateFromStores();
    },

    _onChange: function () {
        this.setState(getStateFromStores());
    },

    checkUserRole: function (role) {
        return this.state.user.includes(role);
    },

    checkFormType: function (formType) {
        return this.state.formType === formType;
    },

    approveFormA: function () {
        const form = restrictionRequestStore.getForm();
        const action = form.sendToTss ? ACTIONS.APPROVE_REQUEST : ACTIONS.APPROVE_VERBAL_FORMA_RESTRICTION;
        ServerActions.submitItemToServer({
            action: action,
            printLata: this.state.printLata,
            requestToSubmit: restrictionRequestStore.restrictionFormattedForSubmission(),
        });
    },

    approveFormB: function () {
        ServerActions.submitItemToServer({
            action: ACTIONS.APPROVE_REQUEST,
            printLata: this.state.printLata,
            requestToSubmit: restrictionRequestStore.restrictionFormattedForSubmission(),
        });
    },

    submitFormB: function () {
        ServerActions.submitItemToServer({
            action: ACTIONS.SUBMIT_REQUEST,
            printLata: this.state.printLata,
            requestToSubmit: restrictionRequestStore.restrictionFormattedForSubmission(),
        });
    },

    updateFormB: function () {
        ServerActions.submitItemToServer({
            action: ACTIONS.UPDATE_REQUEST,
            printLata: this.state.printLata,
            requestToSubmit: restrictionRequestStore.restrictionFormattedForSubmission(),
        });
    },

    modifyFormA: function () {
        ServerActions.submitItemToServer({
            action: ACTIONS.MODIFY_RESTRICTION,
            printLata: this.state.printLata,
            requestToSubmit: restrictionRequestStore.restrictionFormattedForSubmission(),
        });
    },

    approveModifyFormA: function () {
        ServerActions.submitItemToServer({
            action: ACTIONS.APPROVE_REQUEST_TO_MODIFY,
            printLata: this.state.printLata,
            requestToSubmit: restrictionRequestStore.restrictionFormattedForSubmission(),
        });
    },

    updateSlowOrder: function () {
        ServerActions.submitItemToServer({
            action: ACTIONS.SLODT_RESTRICTION,
            printLata: this.state.printLata,
            requestToSubmit: restrictionRequestStore.restrictionFormattedForSubmission(),
        });
    },

    issueFormB: function () {
        ServerActions.submitItemToServer({
            action: ACTIONS.ISSUE_RESTRICTION,
            printLata: this.state.printLata,
            requestToSubmit: restrictionRequestStore.restrictionFormattedForSubmission(),
        });
    },

    issueFormA: function () {
        ServerActions.submitItemToServer({
            action: ACTIONS.ISSUE_RESTRICTION,
            printLata: this.state.printLata,
            requestToSubmit: restrictionRequestStore.restrictionFormattedForSubmission()
        });
    },

    transferOwner: function () {
        ServerActions.submitItemToServer({
            action: ACTIONS.TRANSFER_REQUEST,
            printLata: this.state.printLata,
            id: this.state.restriction.requestId,
            transferredDsId: restrictionRequestStore.getTransferredDsId(),
            requestToSubmit: restrictionRequestStore.restrictionFormattedForSubmission(),
            dsId: territoryStore.getSelectedTerritory()
        });
    },

    turnOnEditMode: function () {
        FormRequestActions.toggleModifyClicked(true);
    },

    cancelEditMode: function () {
        //get out of edit mode
        FormRequestActions.toggleModifyClicked(false);
        // update all states
        this.setState(getStateFromStores());
        // recalculate flags
        FormRequestActions.calculateTracks(restrictionRequestStore.getForm(), true);
    },

    voidRestriction: function () {
        var state = this.state;
        const title = "Confirm Void of " + state.restriction.controlNumber;
        const body = "Are you sure you want to void restriction " + state.restriction.controlNumber + ", between MP " + state.restriction.workStartMp + state.restriction.workStartMpSuffix + " and MP " + state.restriction.workEndMp + state.restriction.workEndMpSuffix + "?";
        if (this.state.isDirty && this.state.formType === TYPES.A) {
            ErrorAction.showModalError("Values on the restriction have been modified. Please reload the form to void");
        } else {
            //Show a checkbox if voiding a form B and if it is before its end time
            let showCheckBox = this.state.formType === TYPES.B && moment() < moment(this.state.restriction.workEndDate + " " + this.state.restriction.workEndTime, "MMDDYY HHmm");

            window.confirm(title,
                {
                    description: body,
                    confirmLabel: 'Void',
                    abortLabel: 'Go Back',
                    showCheck: showCheckBox
                })
                .then(function () {
                    ServerActions.submitItemToServer({
                        action: ACTIONS.VOID_RESTRICTION,
                        printLata: state.printLata,
                        id: state.restriction.requestId,
                        requestToSubmit: restrictionRequestStore.restrictionFormattedForSubmission()
                    });
                });
        }
    },

    deleteRequest: function () {
        var state = this.state;
        window.confirm('Confirm Delete',
            {
                description: 'Are you sure you want to delete this request?',
                confirmLabel: 'Delete',
                abortLabel: 'Go Back'
            })
            .then(function () {
                ServerActions.submitItemToServer({
                    action: ACTIONS.DELETE_REQUEST,
                    printLata: state.printLata,
                    id: state.restriction.requestId,
                    requestToSubmit: restrictionRequestStore.restrictionFormattedForSubmission()
                });
            });

    },

    reset: function () {
        if (this.state.isDirty) {
            window.confirm('Confirm Form Reset',
                {
                    description: 'Resetting this form will abandon all of your work. Are you sure you want to do this?',
                    confirmLabel: 'Reset Form',
                    abortLabel: 'Go Back'
                })
                .then(function () {
                    FormRequestActions.reset();
                    TabActions.switchToPreviousTab();
                    SchematicAPI.resetSchematicNoPrompt();
                });
        }
        else {
            FormRequestActions.reset();
            TabActions.switchToPreviousTab();
            SchematicAPI.resetSchematicNoPrompt();
        }
    },

    callCalculateTracks: function () {
        FormRequestActions.calculateTracks(this.state.restriction)
    },

    render: function () {
        var content = "";
        if (!this.checkUserRole(ROLES.READ_ONLY)) {
            if (this.state.subdivisionSelected) {
                switch (this.state.tabState) {
                    case TABS.issuedFormA:
                    case TABS.issuedFormB:
                    case TABS.requestsFormB:
                    case TABS.requestFormA:
                    case TABS.recentTab:
                        content = "";
                        break;
                    case TABS.entryFormA:
                        content = getButtons(this);
                        break;
                    case TABS.entryFormB:
                        content = getButtons(this);
                        break;
                    case TABS.history:
                        content = "";
                        break;
                    default://show nothing
                        content = "unknown";
                }
            }
            else if (this.state.tabState === TABS.history) {
                content = "";
            }
        }
        content = (
            <div id="batchButtonsDiv">
                {content}
            </div>
        );
        return content;
    }
});

function getButtons(that) {
    return (
        <div id="batchButtonsInnerDiv">
            {determineSubmitButtonType(that)}
            <br />
            <br />
            {!that.state.hideActionButtons && determineDeleteButtonType(that)}
            <br />
            {!that.state.hideActionButtons && determineModifyButtonType(that)}
            <br />
            <br />
            {!that.state.hideActionButtons && determineTransferOwnerButton(that)}
            <br />
            {renderCancelButton(that)}
            <br />
        </div>
    );
}

function determineSubmitButtonType(that) {
    var buttonText = "";
    var submitAction = "";
    var form = that.state.restriction;
    var question = "";
    var disabled = that.state.batchMode;
    let checkCompaction = false;
    if (that.checkUserRole(ROLES.FIELD_SLODT)
        && !(that.checkUserRole(ROLES.FIELD_USER_A))
        && !(that.checkUserRole(ROLES.FIELD_USER_B))) {
        disabled = true;
    }

    if (that.state.didMpEntryChange) {
        return <Button bsStyle="primary" id="submitButton" onClick={that.callCalculateTracks}>Calculate Tracks</Button>;
    } else {
        if (that.state.restriction.status === STATUS.REQUESTED && that.state.restriction.controlNumber > 0) {//Restriction request to modify
            if (that.checkUserRole(ROLES.FIELD_USER_B) ||
                that.checkUserRole(ROLES.FIELD_SLODT)) {//Field user
                return '';
            }
            else if (that.checkUserRole(ROLES.DISPATCHER)) {//Dispatcher
                if (that.state.formType === TYPES.A) {
                    buttonText = "Approve Modify";
                    submitAction = that.approveModifyFormA;
                    question = "modify restriction " + that.state.restriction.controlNumber;
                    // disabled = !that.state.isDirty;
                }
                else {
                    return '';
                }
            }
        }
        else if (that.state.restriction.status === STATUS.REQUESTED) {//If it has a control number greater than 0 it is a request to modify
            if (that.checkUserRole(ROLES.FIELD_USER_B) ||
                that.checkUserRole(ROLES.FIELD_SLODT)) {//Field user
                if (that.state.isModifying) {//Modifying
                    if (that.state.formType === TYPES.A) {
                        checkCompaction = true; //Only check compaction on FormA
                    }
                    buttonText = "Update Request";
                    submitAction = that.updateFormB;
                    question = "update request GR" + that.state.restriction.syncId;
                    if (that.state.formType === TYPES.B && !disabled) {
                        disabled = !that.state.isDirty
                    }
                }
                else {
                    if (that.state.formType === TYPES.A) {
                        buttonText = "Submit Request";
                        submitAction = that.submitFormB;
                        question = "submit this request";
                        checkCompaction = true;
                    }
                    else {
                        buttonText = "Submit Request";
                        submitAction = that.submitFormB;
                        question = "submit this request";
                    }
                }
            }
            else if (that.checkUserRole(ROLES.DISPATCHER)) {//Dispatcher
                if (that.state.formType === TYPES.A) {
                    if (that.state.isModifying) {
                        buttonText = "Issue Restriction";
                        submitAction = that.approveFormA;
                        question = "issue this request";
                    } else {
                        buttonText = "Issue Restriction";
                        submitAction = that.issueFormA;
                        question = "issue this restriction";
                    }

                } else {
                    if (that.state.isModifying) {
                        buttonText = "Issue Restriction";
                        submitAction = that.approveFormB;
                        question = "issue this request";
                    }
                    else {
                        buttonText = "Issue Restriction";
                        submitAction = that.issueFormB;
                        question = "issue this restriction";
                    }
                }
            }
        }
        else if (form.status === STATUS.ISSUED) {//Restriction
            var availableTracks = schematicStore.getTrackData();

            var invalidMfTracks = form.tracks.filter(function (track) {
                var l = availableTracks.length;
                for (var i = 0; i < l; i++) {
                    if (availableTracks[i].name.replace(/ /g, '') === track.name.replace(/ /g, '')) {
                        return false;
                    }
                }
                return true;

            });

            if (form.isPushedFromTss && invalidMfTracks.length > 0) {
                return '';
            }
            else {
                if (that.checkUserRole(ROLES.FIELD_USER_B) ||
                    that.checkUserRole(ROLES.FIELD_SLODT)) {
                    if (that.state.formType === TYPES.A) {
                        buttonText = "Modify Restriction";
                        submitAction = that.updateSlowOrder;
                        question = "modify restriction " + that.state.restriction.controlNumber;
                        checkCompaction = true;
                        if (that.checkUserRole(ROLES.FIELD_SLODT) === -1) {
                            disabled = true;
                        } else {
                            disabled = !that.state.isDirty
                        }
                    }
                    else {
                        return '';
                    }
                }
                else if (that.checkUserRole(ROLES.DISPATCHER)) {
                    if (that.state.formType === TYPES.A) {
                        buttonText = "Modify Restriction";
                        submitAction = that.modifyFormA;
                        question = "modify restriction " + that.state.restriction.controlNumber;
                        disabled = !that.state.isDirty;
                    }
                    else {
                        return '';
                    }
                }
            }

        }
        return <SubmissionConfirmationModal
            buttonText={buttonText}
            submitAction={submitAction}
            form={form}
            disabled={disabled}
            question={question}
            compactionFlag={checkCompaction}  //Pass this to the submission modal to indicate if compaction slow order pop up should be displayed
            modified={that.state.isDirty}
            read={{ only: that.state.isReadOnly }}
        />;
    }
}

function determineDeleteButtonType(that) {
    if (that.state.restriction.status === STATUS.REQUESTED && !that.state.isDirty) {
        if (that.checkUserRole(ROLES.FIELD_USER_B)) {
            if (that.state.isModifying && that.state.restriction.controlNumber === 0) {
                var button = (
                    <Button bsStyle="danger" id="deleteFormbRequest" onClick={that.deleteRequest}
                        disabled={that.state.batchMode}>Delete
                        Request</Button>)
            } else {
                return '';
            }

        }
        else if (that.checkUserRole(ROLES.DISPATCHER) && that.state.formType !== Constants.RestrictionTypes.A) {
            if (that.state.isModifying) {
                var button = (
                    <RejectReasonModal
                        actionCreator={ServerActions}
                        requestId={that.state.restriction.requestId}
                        formType={that.state.formType}
                        reasonCodes={that.state.rejectReasonCodes}
                        printLata={that.state.printLata}
                        disabled={that.state.batchMode} />)
            } else {
                return '';
            }


        }
        else if (that.checkUserRole(ROLES.ADMIN) && that.state.formType === Constants.RestrictionTypes.A) {
            //admin or super user looking at form A
            if (that.state.isModifying
                && that.state.restriction.controlNumber === 0
            ) {
                var button = (
                    <RejectReasonModal
                        actionCreator={ServerActions}
                        requestId={that.state.restriction.requestId}
                        formType={that.state.formType}
                        reasonCodes={that.state.rejectReasonCodes}
                        printLata={that.state.printLata}
                        disabled={that.state.batchMode} />)
            } else {
                return '';
            }
        }
    } else if (that.state.restriction.status === STATUS.ISSUED) {

        if (that.checkUserRole(ROLES.DISPATCHER) || (that.checkUserRole(ROLES.FIELD_USER_A) || 
                that.checkUserRole(ROLES.FIELD_USER)) && fieldUserAllowedToVoid(that)) {

            var button = (
                <Button bsStyle="danger" id="voidFormBRestriction" onClick={that.voidRestriction}
                    disabled={that.state.batchMode}>Void
                    Restriction</Button>)
        } else if (that.checkUserRole(ROLES.FIELD_USER_B)) {
            return '';
        }
    }

    return button;
}

function renderCancelButton(that) {

    if (that.state.isInEditMode) {
        return <Button
            bsStyle="warning"
            id="resetButton"
            disabled={that.state.batchMode}
            onClick={that.cancelEditMode}
            title="Return to list">Cancel</Button>
    }
    else {
        var label = "Clear";
        if (that.state.isModifying) {
            label = "Back";
        }

        return <Button
            bsStyle="warning"
            id="resetButton"
            disabled={that.state.batchMode}
            onClick={that.reset}
            title="Return to list">{label}</Button>
    }
}

function determineModifyButtonType(that) {
    var modifyRequest = "";
    if (that.state.isModifying && !that.state.isInEditMode && that.state.restriction.status === STATUS.REQUESTED && !that.state.isDirty && that.state.formType === Constants.RestrictionTypes.A && that.state.restriction.controlNumber === 0) {
        if (that.checkUserRole(ROLES.DISPATCHER)) {
            modifyRequest = (
                <Button bsStyle="primary" id="modifyRequest"
                    onClick={that.turnOnEditMode}>Edit</Button>
            )
        }
    }

    return modifyRequest;
}

function determineTransferOwnerButton(that) {
    var transferOwner = "";
    if (!that.state.isInEditMode && that.state.isModifying && that.state.restriction.status === STATUS.REQUESTED && !that.state.isDirty && that.state.restriction.controlNumber === 0) {
        if (that.checkUserRole(ROLES.ADMIN) ||
            that.checkUserRole(ROLES.SUPER_USER)) {
            transferOwner = renderTransferOwnerButton(that);
        }
        else if (that.checkUserRole(ROLES.DISPATCHER)) {
            var dispatchers = restrictionRequestStore.getDispatchers();
            for (var x = 0; x < dispatchers.length; x++) {
                if (dispatchers[x].status === "A" || dispatchers[x].status === " ") {
                    transferOwner = renderTransferOwnerButton(that);
                    break;
                }
            }
        }
    }

    return transferOwner;
}

function renderTransferOwnerButton(that) {

    if (that.state.formType === TYPES.B || (that.state.formType === TYPES.A && that.checkUserRole(ROLES.DISPATCHER) !== 0)) {
        var form = that.state.restriction;
        return <TransferModal
            buttonText={"Transfer Owner"}
            submitAction={that.transferOwner} form={form}
            disabled={that.state.batchMode}
            question={"transfer ownership of request GR" + that.state.restriction.syncId}
        />;
    }
    return null;
}

/**
 * Return true when a Field user (ROLES.FIELD_USER) is allowed to void the current restriction.
 * Uses window.gritConfig.reasonCodeExcludedToVoid (comma separated values).
 * If the restriction.reason or restriction.reasonCode contains any excluded token, Field users may NOT void.
 */
function fieldUserAllowedToVoid(that) {
    try {
        if (!that || !that.state || !that.state.restriction) return false;
        // Only applies to Form A per requirement
        if (that.state.formType !== TYPES.A) return false;

        const cfg = window.gritConfig || {};
        const excludedRaw = cfg.reasonCodeExcludedToVoid || '';
        const excludedList = excludedRaw
            .toString()
            .split(',')
            .map(function (s) { return s.trim().toLowerCase(); })
            .filter(function (s) { return s.length > 0; });

        // check possible fields that might contain the reason code
        const reasonVal = ((that.state.restriction.reason || that.state.restriction.reasonCode || '')).toString().toLowerCase();

        if (!reasonVal) return true; // no reason -> allow void for field user

        // If any excluded token is contained in the reason value, deny
        for (var i = 0; i < excludedList.length; i++) {
            if (reasonVal.indexOf(excludedList[i]) !== -1) {
                return false;
            }
        }

        return true;
    } catch (err) {
        // on error, be conservative: deny
        return false;
    }
}